import {
  EVerticalNames,
  OPOS_EDUCATION_ONBOARDING_FORM_STEPS,
  OPOS_ONBOARDING_FORM_STEPS,
  PCE_ONBOARDING_FORM_STEPS,
  SELECTIVITY_ONBOARDING_FORM_STEPS_BY_REGION,
  FP_ONBOARDING_FORM_STEPS,
  ONBOARDING_ALL_FORM_STEPS,
  ERegion,
  ESubVerticalNames
} from '@constants';

type Params = {
  vertical: EVerticalNames | undefined;
  subVertical?: ESubVerticalNames;
  region: ERegion;
};

export const getOnboardingSteps = ({ vertical, subVertical, region }: Params) => {
  if (vertical === EVerticalNames.FP) return FP_ONBOARDING_FORM_STEPS;
  if (vertical === EVerticalNames.OPOS) {
    if (subVertical === ESubVerticalNames.EDU) return OPOS_EDUCATION_ONBOARDING_FORM_STEPS;
    return OPOS_ONBOARDING_FORM_STEPS;
  }
  if (vertical === EVerticalNames.UNI) {
    if (subVertical === ESubVerticalNames.PCE) return PCE_ONBOARDING_FORM_STEPS;
    return (
      SELECTIVITY_ONBOARDING_FORM_STEPS_BY_REGION[region] ||
      SELECTIVITY_ONBOARDING_FORM_STEPS_BY_REGION[ERegion.ES]
    );
  }
  return ONBOARDING_ALL_FORM_STEPS;
};
